import { ViewConfig } from "../core/Workbook";
import {
  SpreadsheetViewConfig,
  viewType as spreadsheetViewType,
} from "datasheets/views/spreadsheet/SpreadsheetViewConfig";

export function viewOwnsDataset(view: ViewConfig): boolean {
  return !view.type || view.type === spreadsheetViewType;
}

export function getOwnedDatasetId(view: ViewConfig): string {
  return (view as SpreadsheetViewConfig).datasetId;
}
